import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type AutocompleteBase from "@/components/Autocomplete.Base.vue";

export default defineMosaicComponent<typeof AutocompleteBase>("components/Autocomplete");
